import './DtcCommerceMmmSkeleton.scss';
import { RectSkeleton, Skeleton } from '@Components/Skeleton';

const PortfolioSummarySkeleton = () => (
  <div className='dtc-skeleton-portfolio'>
    <div className='dtc-skeleton-kpi-grid'>
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className='dtc-skeleton-kpi'>
          <Skeleton>
            <RectSkeleton x={0} y={0} width={80} height={12} rx={4} ry={4} />
            <RectSkeleton x={0} y={24} width={120} height={32} rx={6} ry={6} />
            <RectSkeleton x={0} y={68} width={60} height={10} rx={4} ry={4} />
          </Skeleton>
        </div>
      ))}
    </div>
    <div className='dtc-skeleton-portfolio-aside'>
      <Skeleton>
        <RectSkeleton padding={8} rx={8} ry={8} />
      </Skeleton>
    </div>
  </div>
);

const ChartCardSkeleton = ({ height = 360 }: { height?: number }) => (
  <div className='dtc-skeleton-chart' style={{ height }}>
    <Skeleton>
      <RectSkeleton x={16} y={16} width={160} height={14} rx={4} ry={4} />
      <RectSkeleton x={16} y={40} width={220} height={10} rx={4} ry={4} />
      <RectSkeleton x={16} y={80} width={w => w - 32} height={h => h - 96} rx={8} ry={8} />
    </Skeleton>
  </div>
);

const ChannelPerformanceSkeleton = () => (
  <div className='dtc-skeleton-channel-performance'>
    <Skeleton>
      <RectSkeleton x={16} y={16} width={220} height={16} rx={4} ry={4} />
      <RectSkeleton x={16} y={48} width={w => w - 32} height={40} rx={6} ry={6} />
      {[100, 144, 188, 232, 276, 320, 364].map(y => (
        <RectSkeleton key={y} x={16} y={y} width={w => w - 32} height={32} rx={6} ry={6} />
      ))}
    </Skeleton>
  </div>
);

export const DtcCommerceMmmSkeleton = () => (
  <div className='dtc-commerce-mmm-skeleton'>
    <PortfolioSummarySkeleton />
    <ChannelPerformanceSkeleton />
    <div className='dtc-skeleton-2col'>
      <ChartCardSkeleton />
      <ChartCardSkeleton />
    </div>
  </div>
);
